// src/components/FileIcon.jsx
import React from "react";
import PropTypes from "prop-types";
import "./FileIcon.css";

const iconsMap = {

  //Images
  bmp: "/icons/image-icon.png",
  png: "/icons/image-icon.png",
  jpg: "/icons/image-icon.png",
  jpeg: "/icons/image-icon.png",
  gif: "/icons/image-icon.png",

  //Video
  dav: "/icons/video-icon.png",
  mp4: "/icons/video-icon.png",
  mov: "/icons/video-icon.png",

  //Docs
  docx: "/icons/word-icon.png",
  pdf: "/icons/pdf-icon.png",
  pptx: "/icons/video-icon.png",
  txt: "/icons/txt-icon.png",
  xlsx: "/icons/sheets-icon.png",
  
  //Audio
  wav: "/icons/audio-icon.png",

  folder: "/icons/folder-icon.png",
  
  md: "/icons/text-icon.png",
  zip: "/icons/archive-icon.png",
  rar: "/icons/archive-icon.png",
  
};

export default function FileIcon({ extension }) {
  const src = iconsMap[extension] || "/icons/default-icon.png";
  return (
    <img
      src={src}
      alt={`${extension} file`}
      className="file-icon"
    />
  );
}

FileIcon.propTypes = {
  extension: PropTypes.string.isRequired,
};
